<template>
  <div class="speedee-regular col-sm-12 py-5">
    <span class="speedee-bold">Last Updated: </span>
    <span class="text-success pr-2">{{ updated_at }} </span>
    <i class="fa fa-light fa-check-circle-o" style="color: #17e886"></i>
    <div class="text-start py-4">
      <div class="col-sm-12 px-4">
        <TableComponent
          :columns="myTableColumns"
          :tableData="activityLogs"
          :buttons="buttons"
          @click="handleButtonClick"
          :rows="5"
        >
          <template #filterButtons>
            <div
              class="btn-group mb-2 mr-2"
              role="group"
              v-for="(button, index) in buttons"
              :key="index"
            >
              <Primary
                :index="index"
                :buttonClass="[
                  button.status ? 'btn-warning' : 'bg-light-dark',
                  button.status ? 'text-dark' : 'text-grey',
                ]"
                @click="onPressBtn(index)"
                >{{ button.name }}</Primary
              >
            </div>
          </template>
          <Column
            headerStyle="color: white; background-color: black"
            field="description"
            header="Description"
          >
            <!-- <template #body="slotProps">
          <a href=""></a>
          </template> -->
          </Column>
          <Column
            headerStyle="color: white; background-color: black"
            field="author"
            header="Author & Date/Time"
          ></Column>
          <Column
            headerStyle="color: white; background-color: black"
            field="approved_by"
            header="Approved by & Date/Time"
          >
          </Column>
          <Column
            headerStyle="color: white; background-color: black"
            field="status"
            header="Status"
          >
            <template #body="slotProps">
              <span
                :class="[
                  slotProps.data && slotProps.data.status
                    ? getClass(slotProps.data.status)
                    : '',
                  slotProps.data && slotProps.data.status
                    ? blockStatus(slotProps.data.status)
                    : '',
                  'btn btn-block',
                ]"
                >{{
                  slotProps.data && slotProps.data.statusText
                    ? slotProps.data.statusText
                    : ""
                }}</span
              >
            </template>
          </Column>
          <Column
            headerStyle="color: white; background-color: black"
            field="remarks"
            header="Remarks"
          ></Column>
        </TableComponent>
        <hr />
        <HeroBanner
          :banners="banners"
          v-if="banners && banners.length > 0"
          :product_banners="product_banners"
          :discovers="discovers"
          :icm_banners="icm_banner"
          :wwu_banner="wwu_banner"
          :isApprover="isApprover"
          :isPending="bannerIsPending"
          :isApproved="bannerIsApproved"
        />
        <ICMText
          :icm_banners="icm_banner"
          :isApprover="isApprover"
          :isPending="isIcmPending"
          :isApproved="isIcmApproved"
        />
        <NewSection
          :product_banners="product_banners"
          :isApprover="isApprover"
          :isPending="productIsPending"
          :isApproved="productIsApproved"
        />
        <Discover
          :discovers="discovers"
          :isApprover="isApprover"
          :isPending="discoverIsPending"
          :isApproved="discoverIsApproved"
        />
        <WorkWithUs
          :wwu_banner="wwu_banner"
          :isApprover="isApprover"
          :isPending="wwuIsPending"
          :isApproved="wwuIsApproved"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TableComponent from "@/components/TableComponent.vue";
import SmallButtonComponent from "@/components/SmallButtonComponent.vue";
import ContactBoxComponent from "@/components/ContactBoxComponent.vue";
import HeroBanner from "./HomepageComponents/HeroBanner.vue";
import ICMText from "./HomepageComponents/ICMText.vue";
import NewSection from "./HomepageComponents/NewSection.vue";
import Discover from "./HomepageComponents/Discover.vue";
import WorkWithUs from "./HomepageComponents/WorkWithUs.vue";
import { getRequest, postRequest } from "@/services/RequestService";
import { ref } from "vue";
import dayjs from "dayjs";
import Primary from "@/components/PrimaryButton.vue";
import { checkUserRole } from "@/services/Auth.js";

export default {
  components: {
    TableComponent,
    HeroBanner,
    ICMText,
    NewSection,
    Discover,
    WorkWithUs,
    Primary,
    SmallButtonComponent,
    ContactBoxComponent,
  },

  data() {
    return {
      banners: [],
      bannerIsPending: false,
      icmBannerisPending: false,
      productIsPending: false,
      wwuIsPending: false,
      bannerIsApproved: false,
      isIcmApproved: false,
      productIsApproved: false,
      discoverIsApproved: false,
      wwuIsApproved: false,
      updated_at: dayjs().format("DD-MMM-YYYY"),
      product_banners: [],
      icm_banner: [],
      wwu_banner: [],
      discovers: [],
      isApprover: false,
      headerClass: "table-dark",
      buttons: [
        { status: true, name: "All" },
        { status: false, name: "Approved" },
        { status: false, name: "Pending" },
        { status: false, name: "Rejected" },
        { status: false, name: "Expired" },
      ],
      myTableColumns: [
        { field: "description" },
        { field: "created_by" },
        { field: "status" },
        { field: "approved_by" },
        { field: "remarks" },
        { field: "statusText" },
      ],
      activityLogs: [],
      activityLogsOri: [],
      dataTableOptions: {
        paging: true, // Enable pagination
        searching: true, // Enable search functionality
        lengthChange: false,
        pagingType: "first_last_numbers",
      },
      table: null,
    };
  },

  mounted() {
    this.loadBanners();
    this.checkUserRole();
  },

  methods: {
    async loadBanners() {
      let response = await getRequest("/banners/home/create");
      this.banners = response.data.data.banners.map((banner, index) => ({
        ...banner,
        banner_expanded: index === 0,
      }));
      this.wwu_banner = response.data.data.wwu_banners;
      this.icm_banner = response.data.data.icm_banners;
      this.activityLogs = response.data.data.logs;
      this.activityLogsOri = response.data.data.logs;
      this.updated_at = response.data.data.last_updated_at;

      let product_banners = await getRequest("/banners/products/create");
      this.product_banners = product_banners.data.data.map(
        (products, index_1) => ({
          ...products,
          products_expanded: index_1 === 0,
        })
      );

      let discovers = await getRequest("/discovers/create");
      this.discovers = discovers.data.data.map((discover, index_2) => ({
        ...discover,
        discover_expanded: index_2 === 0,
      }));

      /**** for pending status ****/
      this.banners.forEach((banner, index) => {
        this.bannerIsPending = banner.approval === "Pending";
        this.bannerIsApproved =
          banner.approval === "Approved" ||
          banner.approval === "Rejected";
      });
      this.isIcmPending = this.icm_banner.approval === "Pending";
      this.isIcmApproved =
        this.icm_banner.approval === "Approved" ||
        this.icm_banner.approval === "Rejected";
      this.product_banners.forEach((product, index) => {
        this.productIsPending = product.approval === "Pending";
        this.productIsApproved =
          product.approval === "Approved" ||
          product.approval === "Rejected";
      });

      this.discovers.forEach((discover, index) => {
        this.discoverIsPending = discover.approval === "Pending";
        this.discoverIsApproved =
          discover.approval === "Approved" ||
          discover.approval === "Rejected";
      });
      this.wwuIsPending = this.wwu_banner.approval === "Pending";
      this.wwuIsApproved =
        this.wwu_banner.approval === "Approved" ||
        this.wwu_banner.approval === "Rejected";
      // console.log("pending: " + JSON.stringify(this.isIcmPending));
    },

    async checkUserRole() {
      this.isApprover = await checkUserRole();
    },

    async onPressBtn(int) {
      this.buttons.forEach((button, index) => {
        button.status = int === index;
      });

      this.changeFilter(int);
    },

    resetLogsArr() {
      this.activityLogs = this.activityLogsOri;
    },

    async changeFilter(index) {
      this.resetLogsArr();
      if (index === 1) {
        let newArr = [];

        this.activityLogs.forEach((element) => {
          if (element.statusText == "Approved") {
            newArr.push(element);
          }
          this.activityLogs = newArr;
        });
      }
      if (index === 2) {
        let newArr = [];

        this.activityLogs.forEach((element) => {
          if (element.statusText == "Pending") {
            newArr.push(element);
          }
          this.activityLogs = newArr;
        });
      }
      if (index === 3) {
        let newArr = [];

        this.activityLogs.forEach((element) => {
          if (element.statusText == "Rejected") {
            newArr.push(element);
          }
          this.activityLogs = newArr;
        });
      }
      if (index === 4) {
        let newArr = [];

        this.activityLogs.forEach((element) => {
          if (element.statusText == "Expired") {
            newArr.push(element);
          }
          this.activityLogs = newArr;
        });
      }
    },

    getClass(status) {
      switch (status) {
        case 1:
          return "text-warning";
        case 2:
          return "text-success";
        case 3:
          return "text-danger";
        case 4:
          return "text-brown";
        default:
          return "text-grey";
      }
    },

    blockStatus(status) {
      switch (status) {
        case 1:
          return "bg-light-warning";
        case 2:
          return "bg-light-success";
        case 3:
          return "bg-light-danger";
        case 4:
          return "bg-light-brown";
        default:
          return "bg-light-dark";
      }
    },
  },
};
</script>

<style scoped>
.badge.badge-info {
  background-color: #b69a814b;
}

.icon_contain {
  text-align: center;
}

.image-grid-custom {
  display: flex;
  justify-content: center;
}

.image-item-custom {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 7%;
}

.image-icon {
  max-width: 70%;
  height: auto;
}

.image-text {
  margin-top: 10px;
  font-size: 1vw;
  font-weight: bold;
  word-wrap: break-word;
}

.card {
  border: none;
}

.custom-size {
  width: 30px !important;
  height: 30px !important;
}

.btn-width {
  width: 15vw;
}

.btn-text {
  font-size: 1vw;
}

.box-container {
  display: grid;
  grid-template-columns: repeat(4, minmax(300px, 1fr));
  /* Adjust the minmax value as needed */
  grid-gap: 20px;
}

@media (max-width: 1609px) {
  .box-container {
    grid-template-columns: repeat(4, minmax(150px, 1fr));
  }
}

@media (max-width: 1208px) {
  .box-container {
    grid-template-columns: repeat(2, minmax(200px, 1fr));
  }
}

@media (max-width: 1141px) {
  .box-container {
    grid-template-columns: repeat(2, minmax(200px, 1fr));
  }
}

@media screen and (max-width: 574px) {
  .box-container {
    grid-template-columns: repeat(2, minmax(200px, 1fr));
    width: 100%;
  }
}

@media screen and (max-width: 573px) {
  .box-container {
    grid-template-columns: repeat(1, minmax(200px, 1fr));
    width: 100%;
  }
}

@media screen and (max-width: 480px) {
  .box-container {
    grid-template-columns: repeat(1, minmax(200px, 1fr));
    width: 100%;
  }
}

@media screen and (max-width: 287px) {
  .box-container {
    grid-template-columns: repeat(1, minmax(200px, 1fr));
    width: 100%;
  }
}

@media screen and (max-width: 260px) {
  .box-container {
    grid-template-columns: repeat(1, minmax(150px, 1fr));
    width: 100%;
  }
}

.text-brown {
  background-color: #a87b63 !important;
}

.bg-light-brown {
  background-color: #ebe0da !important;
}

.cursor-container {
  cursor: default;
}

.cursor-container:hover {
  cursor: pointer;
}
</style>